import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ filters, onFilterChange, onSearchChange, searchQuery }) => {
  const sortOptions = [
    { value: 'recent', label: '최근 생성순' },
    { value: 'oldest', label: '오래된순' },
    { value: 'progress', label: '인증 많은순' },
    { value: 'alphabetical', label: '가나다순' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="relative">
          <Input
            type="search"
            placeholder="목표 검색..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
          <Icon
            name="Search"
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
        </div>

        <Select
          options={sortOptions}
          value={filters?.sort}
          onChange={(value) => onFilterChange('sort', value)}
          placeholder="정렬 기준"
        />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {searchQuery && (
          <div className="flex items-center space-x-2 px-3 py-1 bg-accent/20 text-accent rounded-md text-sm">
            <span className="caption">검색: {searchQuery}</span>
            <button
              onClick={() => onSearchChange('')}
              className="hover:opacity-70 transition-gaming"
            >
              <Icon name="X" size={14} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterControls;